import { render, staticRenderFns } from "./ResearchHeatmap.vue?vue&type=template&id=a9d7f6ce"
import script from "./ResearchHeatmap.vue?vue&type=script&lang=js"
export * from "./ResearchHeatmap.vue?vue&type=script&lang=js"
import style0 from "./ResearchHeatmap.vue?vue&type=style&index=0&id=a9d7f6ce&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9d7f6ce')) {
      api.createRecord('a9d7f6ce', component.options)
    } else {
      api.reload('a9d7f6ce', component.options)
    }
    module.hot.accept("./ResearchHeatmap.vue?vue&type=template&id=a9d7f6ce", function () {
      api.rerender('a9d7f6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchHeatmap.vue"
export default component.exports